import BellIcon from '@components/Icons/BellIcon';
import { HouseIcon } from '@components/Icons/HouseIcon';
import { SearchIcon } from '@components/Icons/SearchIcon';
import { debugStore } from '@stores/Debug';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import styles from './BevelButtonPage.module.scss';

export const BevelButtonPage = observer(() => {
  const navigate = useNavigate();

  if (!debugStore.respectfulDebugMode) {
    return <div style={{ width: '100vw', height: '100dvh' }} />;
  }

  return (
    <div className={styles.page}>
      <span className={styles.label}>Circular icon buttons</span>
      <div className={styles.row}>
        <button className={styles.circleButton}>
          <SearchIcon />
        </button>
        <button className={styles.circleButton}>
          <HouseIcon />
        </button>
        <button className={styles.circleButton}>
          <BellIcon />
        </button>
      </div>

      <span className={styles.label}>Pill buttons</span>
      <div className={styles.row}>
        <button className={styles.pillButton}>Search</button>
        <button className={styles.pillButton}>Upload media</button>
        <button className={styles.pillButton} onClick={() => navigate(-1)}>
          Go back
        </button>
      </div>
    </div>
  );
});
